import { createContext, FC, PropsWithChildren, useContext } from "react";
import { TOnboardingConfig } from "../../app/models";

type OnboardingConfigContextValue = {
  config: TOnboardingConfig | null;
  isLoading: boolean;
};

const OnboardingConfigContext = createContext<OnboardingConfigContextValue>(
  {} as OnboardingConfigContextValue
);

export const OnboardingConfigProvider: FC<
  PropsWithChildren<OnboardingConfigContextValue>
> = ({ children, config, isLoading }) => (
  <OnboardingConfigContext.Provider value={{ config, isLoading }}>
    {children}
  </OnboardingConfigContext.Provider>
);

export const useOnboardingConfig = (): OnboardingConfigContextValue =>
  useContext(OnboardingConfigContext);
